/* src/app/home/partials/vehicle-availability-graph/vehicle-availability-graph.component.scss */
b {
  color: #1e293b;
  font-size: 0.95rem;
}
hr {
  margin: 0.5rem 0 0.75rem;
  border-color: #eef2f6;
}
/*# sourceMappingURL=vehicle-availability-graph.component.css.map */
